import { render, staticRenderFns } from "./MobileAbout.vue?vue&type=template&id=123c2ad4&scoped=true&"
import script from "./MobileAbout.vue?vue&type=script&lang=js&"
export * from "./MobileAbout.vue?vue&type=script&lang=js&"
import style0 from "./MobileAbout.vue?vue&type=style&index=0&id=123c2ad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c2ad4",
  null
  
)

export default component.exports